import $ from 'jquery';

export function findData(rawData){
  // Determine which variable to port in from the school's JSON file
  const chartableData = rawData.yearly_data.slice(0, 11).reverse();
   
  chartableData.push({year: "19-20", applications: null,
      appropriations: null,
      endowment: null,
      enrollment: null,
      perc_admitted: null,
      perc_yield: null,
      retention: null,
      tuition: null,
      tuition_instruction: null
  })

   chartableData[9]['applications'] = null
   chartableData[9]['appropriations'] = null
   chartableData[9]['endowment'] = null
   chartableData[9]['perc_admitted'] = null
   chartableData[9]['perc_yield'] = null
   chartableData[9]['tuition'] = null
   chartableData[9]['tuition_instruction'] = null

  return chartableData;
}

export default {findData}